import { Box, Chip, CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ExecutionResultDto } from '../../../types/ExecuteFunctionDto'

interface ResponseTabProps {
  result: ExecutionResultDto | null
  isExecuting: boolean
}

const ResponseTab = ({ result, isExecuting }: ResponseTabProps) => {
  const { t } = useTranslation()

  if (isExecuting) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!result) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'text.secondary' }}>
        <Typography>{t('command.noResponse', 'Execute a function to see the response')}</Typography>
      </Box>
    )
  }

  const isSuccess = result.statusCode >= 200 && result.statusCode < 300

  let formattedBody = result.responseBody
  try {
    formattedBody = JSON.stringify(JSON.parse(result.responseBody), null, 2)
  } catch {
    // not JSON, show raw
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="subtitle2">{t('command.statusCode', 'Status')}</Typography>
        <Chip label={result.statusCode} size="small" color={isSuccess ? 'success' : 'error'} />
      </Box>
      {formattedBody && formattedBody !== '{}' && (
        <Box
          sx={{
            flex: 1,
            bgcolor: 'grey.900',
            borderRadius: 1,
            p: 2,
            overflow: 'auto',
            fontFamily: 'monospace',
            fontSize: 12,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            color: isSuccess ? 'success.light' : 'error.light',
          }}
        >
          {formattedBody}
        </Box>
      )}
    </Box>
  )
}

export default ResponseTab
